export default __webpack_public_path__ + "static/g-hands-0cdcba39f002b6d8a7536b71427bb837.jpg";